// Dev-only: avoids "ResizeObserver loop completed with undelivered notifications."
// The browser reports this harmless warning when an observer callback resizes something that is
// observed again in the same frame. The webpack dev-server overlay shows it as a full-screen error.
// Running the callbacks on the next animation frame removes the warning without changing behaviour.
// Production builds are not touched.
if (process.env.NODE_ENV === "development" && typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}
